export function hasMarketingDept(state) {
  return !!(state.unlockedTech?.includes('D4'));
}

export function hasBrandBuilder(state) {
  return !!(state.unlockedTech?.includes('D2'));
}
